<template>
  <div class="qr-section-wrapper content-wrapper">
    <progress-bar :currentStep="2"></progress-bar>

    <div class="header-request">
      <h3>{{ instruction.message }}</h3>
    </div>

    <div class="qr-img-wrapper">
      <img class="qr-img" :src="instruction.options" alt="QR Code" />
    </div>
  </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'

export default {
  name: 'QrScan',

  components: {
    ProgressBar,
  },
  mixins: [blockBackNavigationMixin],

  props: {
    instruction: {
      type: Object,
      default: () => {
        // Default value thats populated with the instruction being sent from backend
      },
    },
  },

  data() {
    return {
      MockQr: require('../assets/images/mock_qr.png'),
    }
  },
}
</script>

<style scoped lang="scss">
.qr-img-wrapper {
  margin: 0 auto 90px auto;
  width: 40%;
  position: relative;

  @media screen and (max-width: $mobile-resolution) {
    width: 80%;
    padding: 0;
    height: 40vh;
    padding-top: 22px;
  }

  & .qr-img {
    width: 100%;
    padding: 5px;
    box-shadow: 0px 5px 10px rgba(212, 212, 212, 0.25);
    border-radius: 8px;
    border: 1px solid #f1f1f1;
  }
}
</style>
